import { Route, Routes } from "react-router-dom";
import ScrollToTop from "./hooks/ScrollToTop";
import MainLayout from "./layouts/MainLayout";
import NotFound from "./pages/404";
import AboutUs from "./pages/about";
import Contact from "./pages/Contact";
import GetInvolved from "./pages/GetInvolve.jsx";
import MainPage from "./pages/main/index";
import OurWork from "./pages/OurWork";
import "./i18n";

export default function App() {
  return (
    <div className="w-full h-screen">
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<MainPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
